import { render, staticRenderFns } from "./EditGeoData.vue?vue&type=template&id=50717634&"
import script from "./EditGeoData.vue?vue&type=script&lang=js&"
export * from "./EditGeoData.vue?vue&type=script&lang=js&"
import style0 from "./EditGeoData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/web apps/HMS_Web_App_Vue/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VFlex,VLayout,VProgressLinear})
